// import { scroller } from 'react-scroll';

import {
    EDIT_SECTION_REQUESTED,
    EDIT_SECTION_COMPLETED,
    EDIT_SECTION_ERROR,
} from './types';

const editSectionAction = async (section) => async (dispatch) => {
    dispatch({
        type: EDIT_SECTION_REQUESTED,
    });

    try {
        return dispatch({
            type: EDIT_SECTION_COMPLETED,
            payload: section,
        });
    } catch (err) {
        return dispatch({
            type: EDIT_SECTION_ERROR,
            payload: err,
        });
    }
};

export default editSectionAction;
